import {Success} from '../Success';

export class Factory {

    // ########################################

    public create(data: any, warnings: { code: number; message: string, additional_data: string }[] = []): Success {
        return new Success(
            data,
            warnings
        );
    }

    // ########################################
}
